<template>
  <!-- 上册立即订阅，二次弹窗 -->

  <div>
    <van-overlay :show="true">
      <div class="volumeContent" :style="isShow">
        <!-- 展示书籍图片 -->
        <div :class="!bookType ? 'volumeBookImage' : 'volumeBookImage volumeBookImage_bottom'">
          <img v-lazy="imgUrl || {}" />
          <div v-if="isShiJuan" class="volumeBookAfter">试卷</div>
        </div>

        <!-- 书籍信息、按钮-->
        <div :class="bookType ? 'bookInformation bookInformation_height' : 'bookInformation'">
          <div v-if="!bookType" style="padding-top:100px;">
            <p class="information_title">您即将订阅的书籍是</p>
            <div class="information_editions">
              <!-- <p class="infor_edition">数学 人教版 六年级上册</p> -->
              <p class="infor_edition">
                {{
                  catalogueData.versionName +
                    catalogueData.courseName +
                    catalogueData.gradesName +
                    catalogueData.volumeName
                }}
              </p>
              <p class="infor_edition_title">
                {{ catalogueData.name ? catalogueData.name : catalogueData.abbrName }}
              </p>
            </div>
            <p v-if="!isShiJuan" class="infor_caveat">请再次确认上图与您的书籍封面一致</p>
            <p v-if="isShiJuan" class="infor_caveat">
              请再次确认您要购买的是书籍<span style="color: #ff7e33">配套试卷</span>
            </p>
          </div>
          <div v-if="bookType" style="padding-top:103px;" class="newBookvolume">
            <p class="hint_title">温馨提示</p>
            <div class="centent_title">
              您即将订阅的为<span style="color:#FE7B21;">非本学期使用 </span>
              的书籍，确定要继续订阅吗?
            </div>
          </div>
          <!-- 按钮 -->
          <div class="infor_buttonCont clearfix">
            <div class="infor_btn_cancel" @click.stop="hiddenConfirmAlert">取消</div>
            <div v-if="fixedNum > 0" class="infor_btn_determine">
              确认无误<span>（{{ fixedNum }}s）</span>
            </div>
            <div
              v-if="fixedNum === 0"
              class="infor_btn_determineAcitve"
              @click.stop="toPaymentPage"
            >
              确认无误
            </div>
          </div>
          <!-- 底部提示文字 -->
          <div class="infor_footerFont">
            <img
              src="https://img.yzcdn.cn/upload_files/2020/10/30/FhjXCZnw2eqy2x6OylX7UNEoDoww.png"
            />
            <span>订阅成功后，不可退款</span>
          </div>
          <div style="height:10rem;"></div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Overlay } from 'vant'
export default {
  components: {
    [Overlay.name]: Overlay
  },
  /**
   * workbook_id 书的id
   * imgUrl 书的图片
   * topAlertsShow 显示内容
   */
  props: {
    // 是否为当前册次
    bookType: {
      type: Boolean,
      default: false
    },
    imgUrl: {
      type: Object,
      default: null
    },
    catalogueData: {
      type: Object,
      default: null
    },
    workbookId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: 'transform: translateY(100%);',
      subject: null,
      edition: null,
      grade: null,
      name: null,
      timer: null,
      fixedBtn: false,
      fixedNum: 3,
      isShiJuan: false
    }
  },
  watch: {
    fixedNum(news, low) {
      if (news === 0) {
        clearInterval(this.timer)
      }
    }
  },
  created() {
    this.name = (this.catalogueData.name || this.catalogueData.abbrName)
      .replace(this.catalogueData.courseName, '')
      .replace(this.catalogueData.versionName, '')
      .replace(this.catalogueData.gradesName, '')
      .replace(this.catalogueData.volumeName, '')
    this.name.indexOf('试卷') === -1 ? (this.isShiJuan = false) : (this.isShiJuan = true)
    setTimeout(() => {
      this.show()
    }, 100)

    // 倒计时3s
    this.timer = setInterval(() => {
      this.fixedNum--
    }, 1000)
  },
  methods: {
    show() {
      this.isShow = 'transform: translateY(0);'
    },
    // 隐藏弹框
    hiddenConfirmAlert() {
      this.$emit('showConfirmAlert')
    },
    // 跳转支付页面
    toPaymentPage() {
      if (this.bookType) {
        this.$router.push({
          path: 'bookOrder',
          query: { id: this.workbookId, channel: 'db_ymy_n_gn' }
        })
      }
      this.$emit('toPaymentPages')
    }
  }
}
</script>

<style scope>
.clearfix::after {
  content: '';
  display: block;
  width: 0px;
  height: 0px;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}

.volumeContent {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateY(100%);
  transition: all 0.3s;
}

/* 展示书籍图片 */
.volumeBookImage {
  width: 142px;
  height: 200px;
  position: absolute;
  bottom: 296px;
  left: 50%;
  transform: translate(-50%);
  z-index: 98;
  /* margin-left: -71px; */
  border-radius: 8px;
  box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.12);
}
.volumeBookImage_bottom {
  bottom: 280px;
}

.volumeBookAfter {
  /* display: block; */
  /* content: '试卷'; */
  width: 59px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 18px;
  font-weight: bold;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border-radius: 0 10px 0 10px;
}

.volumeBookImage img {
  width: 142px;
  height: 200px;
  border-radius: 8px;
}
.newBookvolume {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.hint_title {
  color: rgba(118, 125, 142, 1);
  font-size: 20px;
}
.centent_title {
  width: 334px;
  height: 82px;
  border: 1px solid #fff3eb;
  background: #fffbf8;
  border-radius: 11px;
  margin-top: 13px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #343a50;
  padding: 11px 32px 0 26px;
  box-sizing: border-box;
}
/* 书籍信息 */
.bookInformation {
  width: 100%;
  height: 385px;
  text-align: center;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 16px 16px 0px 0px;
  position: absolute;
  z-index: 97;
  bottom: 0;
  left: 0;
}
.bookInformation_height {
  height: 360px;
}
.information_title {
  font-weight: 500;
  font-size: 16px;
  color: #767d8e;
  margin-bottom: 12px;
}

.information_editions {
  width: 334px;
  max-height: 93px;
  background: #fffbf8;
  border: 1px solid #fff3eb;
  border-radius: 11px;
  margin: auto;
  text-align: center;
  margin-bottom: 12px;
  padding: 11px 0px;
}

.infor_edition {
  font-weight: 500;
  font-size: 20px;
  color: #343a50;
  line-height: 1;
  margin-bottom: 8px;
}

.infor_edition_title {
  width: 228px;
  font-weight: 500;
  font-size: 20px;
  color: #ff7e33;
  line-height: 26px;
  margin: auto;
}

.infor_caveat {
  font-size: 17px;
  color: #767d8e;
  line-height: 1;
  margin-bottom: 12px;
}

/* 底部按钮 */
.infor_buttonCont {
  padding-left: 20px;
  margin-bottom: 10px;
}

.infor_btn_cancel {
  width: 162px;
  height: 50px;
  font-size: 18px;
  color: #c2c2c2;
  line-height: 50px;
  border: 1px solid #ecebeb;
  border-radius: 8px;
  float: left;
  margin-right: 11px;
}

.infor_btn_determine {
  width: 162px;
  height: 50px;
  font-size: 18px;
  color: #ffffff;
  line-height: 50px;
  border-radius: 8px;
  background: linear-gradient(0deg, #cccccc, #cccccc),
    linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
  float: left;
}

.infor_btn_determineAcitve {
  width: 162px;
  height: 50px;
  font-size: 18px;
  color: #ffffff;
  line-height: 50px;
  border-radius: 8px;
  background: linear-gradient(90deg, #fd735d 0.16%, #ff423c 100.16%);
  float: left;
}

.infor_footerFont {
  /* text-align: center; */
  /* display: flex; */
  margin-bottom: 20px;
  /* justify-items: center; */
  height: 30px;
  line-height: 30px;
  margin: 0 auto;
}

.infor_footerFont img {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
}

.infor_footerFont span {
  font-size: 17px;
  color: #ff2638;
  vertical-align: middle;
}
</style>
